import UploadHistoryPanel from './upload-history-panel';

const UploadHistory = ({data}) => (
  <div className="fluid">
    {data.map((value, key) =>
      <UploadHistoryPanel data={value} key={key}/>)}
  </div>
);


export default UploadHistory;
